import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import DealerCarInfoHeader from "./components/DealerCarInfoHeader";
import Interventions from "./components/Interventions";
import Checks from "./components/Checks";
import LabelImages from "./components/LabelImages";
import ActivityLog from "./components/ActivityLog";
import DeskCommunicationLog from "./components/DeskCommunicationLog";
import KioskCommunicationLog from "./components/KioskCommunicationLog";
import { normalizeAppointmentData, getAllImages } from "./util";

import Service from "./service";

import "./index.scss";

class AppointmentReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      failedToLoad: false,
      appointment: null,
    };
  }

  componentDidMount = () => {
    const { match, i18n } = this.props;
    const routeKey = match.params.routeKey;

    if (routeKey) {
      Service.loadReport(routeKey)
        .then(result => {
          if (result.data?.data?.report) {
            try {
              const appointment = JSON.parse(result.data.data.report);

              i18n.changeLanguage(appointment.dealer_location.language_code || "en-GB");
              this.setState({
                appointment: normalizeAppointmentData(appointment),
                failedToLoad: false,
              });
            } catch (e) {
              this.setState({ failedToLoad: true });
              console.log("Failed to parse data", e);
            }
          } else {
            this.setState({ failedToLoad: true });
            console.log("Failed to load report");
          }
        })
        .catch(err => {
          this.setState({ failedToLoad: true });
          console.log("Failed to load report", err);
        });
    } else this.setState({ failedToLoad: true });
  };

  render() {
    const { failedToLoad, appointment } = this.state;

    if (failedToLoad || !appointment) return null;

    const images = getAllImages(appointment);

    return (
      <div className="AppointmentReport">
        <DealerCarInfoHeader appointment={appointment} />
        <Interventions interventions={appointment.interventions} settings={appointment.dealer_location} />
        {appointment.checks?.map(check => (
          <Checks key={check.id} check={check} settings={appointment.dealer_location} />
        ))}
        {appointment.pdf_include_customer_sign_logs && (
          <>
            <DeskCommunicationLog appointment={appointment} />
            <KioskCommunicationLog appointment={appointment} />
          </>
        )}
        <ActivityLog appointment={appointment} />
        {images?.length > 0 && <LabelImages images={images} />}
      </div>
    );
  }
}

export default withRouter(withTranslation()(AppointmentReport));
